
import { supabase } from "@/integrations/supabase/client";

export const deleteLeadById = async (leadId: string): Promise<{ success: boolean, error?: string }> => {
  try {
    console.log("Deleting lead by ID:", leadId);
    const { error } = await supabase
      .from('leads')
      .delete()
      .eq('id', leadId);
    
    if (error) {
      console.error("Error deleting lead:", error);
      throw new Error(`Supabase error: ${error.message} (code: ${error.code})`);
    }
    
    console.log("Lead deleted successfully");
    return { success: true };
  } catch (error) {
    console.error("Error in deleteLeadById:", error);
    return { 
      success: false, 
      error: error instanceof Error ? error.message : "Unknown error occurred" 
    };
  }
};

export const deleteMultipleLeads = async (leadIds: string[]): Promise<{ success: boolean, error?: string, count: number }> => {
  try {
    console.log(`Deleting ${leadIds.length} leads. IDs:`, leadIds);
    const { error } = await supabase
      .from('leads')
      .delete()
      .in('id', leadIds);
    
    if (error) {
      console.error("Error deleting multiple leads:", error);
      throw new Error(`Supabase error: ${error.message} (code: ${error.code})`);
    }
    
    console.log(`${leadIds.length} leads deleted successfully`);
    return { success: true, count: leadIds.length };
  } catch (error) {
    console.error("Error in deleteMultipleLeads:", error);
    return { 
      success: false, 
      count: 0,
      error: error instanceof Error ? error.message : "Unknown error occurred" 
    };
  }
};
